import { SxSViewState, PreviewPaneMode, WacPreviewState } from 'owa-sxsdata';
import loc, { isStringNullOrWhiteSpace } from 'owa-localize';
import { saveStatusDefaultText } from './getSaveStatusText.locstring.json';

export function getSaveStatusText(viewState: SxSViewState): string | null {
    if (!viewState.previewPane) {
        return null;
    }

    switch (viewState.previewPane.mode) {
        case PreviewPaneMode.Wac:
            const wacViewState = viewState.previewPane as WacPreviewState;
            return isStringNullOrWhiteSpace(wacViewState.saveStatusText)
                ? loc(saveStatusDefaultText)
                : wacViewState.saveStatusText;
        default:
            return null;
    }
}
